<div class="d-flex flex-column gap-3 flex-fill overflow-hidden">
  <div class="flex-shrink-0">
    <deal-financial-summary [summary]="summary()" />
  </div>

  <div class="d-flex flex-column flex-fill overflow-hidden pb-3">
    <deal-deposits-table
      (depositsSaved)="onDepositFormSubmitted()"
      (depositPayment)="onDepositPaymentFormSubmitted($event)"
      [deposits]="deposits()"
      (deleteDeposit)="onConfirmDeleteDeposit()"
      (deleteDepositPayment)="onConfirmDeleteDepositPayment()"
      (bulkDeleteDeposits)="onBulkDeleteDeposits($event)"
      (imports)="openImportsModal($event)"
    />
  </div>
</div>

<ng-template #importsModal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3">
      <h2 class="modal-title">Import Deposits</h2>
      <span role="button" class="ms-auto" (click)="close()">
        <svg-icon name="modal-close-menu" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body overflow-hidden">
      <lib-imports-model (selectedLot)="onSelectedLot($event)" [importType]="importType()" />
    </div>
    <div class="modal-footer">
      <button class="btn btn-shadow" type="button" (click)="close()">Cancel</button>
      @if (canWriteDeals()) {
        <button class="btn btn-primary" type="button" (click)="onImportData()">Import Deposits</button>
      }
    </div>
  </div>
</ng-template>
